import { useCallback, useEffect, useState } from 'react';

import { RequiredUserActionsDto } from 'lib_api/lib/api/gen';

import { useApi } from 'hooks/ApiStoreContext';

import { backAlertMessage } from '../utils/backAlertMessage';

export const useRequiredActions = (): [
  RequiredUserActionsDto | undefined,
  () => void,
] => {
  const [requiredActions, setRequiredActions] =
    useState<RequiredUserActionsDto>();
  const { ComptesUtilisateursControllerApi } = useApi();

  const updateRequiredActions = useCallback(() => {
    ComptesUtilisateursControllerApi.getRequiredActionsUsingGET()
      .then(requiredActionsDto => setRequiredActions(requiredActionsDto))
      .catch((e: Response) => backAlertMessage(e));
  }, [ComptesUtilisateursControllerApi]);

  useEffect(updateRequiredActions, [ComptesUtilisateursControllerApi]);

  return [requiredActions, updateRequiredActions];
};
